const getLocalStorage = (key) => {
  let output;
  try {
    const storedValue = localStorage.getItem(key);
    if (!!storedValue) {
      output = storedValue;
    }
  } catch (err) {}
  return output;
};

export default getLocalStorage;
